import { render, staticRenderFns } from "./plus-btn.vue?vue&type=template&id=4ddc6c6c&scoped=true&"
import script from "./plus-btn.vue?vue&type=script&lang=ts&"
export * from "./plus-btn.vue?vue&type=script&lang=ts&"
import style0 from "./plus-btn.vue?vue&type=style&index=0&id=4ddc6c6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddc6c6c",
  null
  
)

export default component.exports